import { render, staticRenderFns } from "./PlatformInquiryDrawer.vue?vue&type=template&id=15a74e48&scoped=true"
import script from "./PlatformInquiryDrawer.vue?vue&type=script&lang=js"
export * from "./PlatformInquiryDrawer.vue?vue&type=script&lang=js"
import style0 from "./PlatformInquiryDrawer.vue?vue&type=style&index=0&id=15a74e48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a74e48",
  null
  
)

export default component.exports